import { render } from "./ArticleTabbedCarousel.vue?vue&type=template&id=21d3ff7c&scoped=true"
import script from "./ArticleTabbedCarousel.vue?vue&type=script&lang=js"
export * from "./ArticleTabbedCarousel.vue?vue&type=script&lang=js"

import "./ArticleTabbedCarousel.vue?vue&type=style&index=0&id=21d3ff7c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d3ff7c"]])

export default __exports__